/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { history } from "../../router/router";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";
import { ImgStatic } from "./element/ImgStatic";
import { CREATE_YOUR_OWN_APP } from "../../config.json";

export interface NavbarProps {
  sideMenuClicked: boolean;
  setSideMenuClicked(b: boolean): void;
}

function Navbar({ setSideMenuClicked, sideMenuClicked }: NavbarProps) {
  const [showLogOutDropdown, setShowLogOutDropdown] = useState<boolean>(false);

  const mainPageData = useMainPageDataSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    const navBar = document.getElementById("navbar-header");
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 0) {
        navBar?.classList.add("minimized");
      } else {
        navBar?.classList.remove("minimized");
      }
    });
  }, []);

  return (
    <nav
      className="navbar navbar-expand-sm navbar-light bg-white nav fixed-top"
      id="navbar-header"
    >
      <div className="container">
        <Link className="navbar-brand" to="/">
          <ImgStatic name="company-logo-small.png" />
        </Link>
        <a
          className={
            sideMenuClicked
              ? "mobile-menu-btn mobile-menu-open-btn d-sm-none d-block inactive"
              : "mobile-menu-btn mobile-menu-open-btn d-sm-none d-block"
          }
          onClick={() => {
            setSideMenuClicked(true);
          }}
        >
          <span className="mobile-menu-strip mobile-menu-strip-1"></span>
          <span className="mobile-menu-strip mobile-menu-strip-2"></span>
          <span className="mobile-menu-strip mobile-menu-strip-3"></span>
        </a>
        <a
          className={
            sideMenuClicked
              ? "mobile-menu-btn mobile-menu-close-btn d-sm-none d-block active"
              : "mobile-menu-btn mobile-menu-close-btn d-sm-none d-block"
          }
          onClick={() => {
            setSideMenuClicked(false);
          }}
        >
          <span className="mobile-menu-strip mobile-menu-strip-1"></span>
          <span className="mobile-menu-strip mobile-menu-strip-3"></span>
        </a>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a
                href={CREATE_YOUR_OWN_APP}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <i className="fas fa-plus"></i> Create Your Own App
              </a>
            </li>
            {mainPageData.authState ? (
              <li
                className={
                  showLogOutDropdown
                    ? "nav-item dropdown show"
                    : "nav-item dropdown"
                }
              >
                <button
                  className="dropdown-toggle btn btn btn-light"
                  id="navbarDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowLogOutDropdown(!showLogOutDropdown);
                  }}
                >
                  {mainPageData.appUser?.firstName
                    ? mainPageData.appUser?.firstName
                    : mainPageData.appUser?.msisdn}
                </button>
                <div
                  className={
                    showLogOutDropdown
                      ? "dropdown-menu border-0 rounded-0 shadow show"
                      : "dropdown-menu border-0 rounded-0 shadow"
                  }
                  aria-labelledby="navbarDropdown"
                >
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      dispatch({
                        type: MainPageEvent.SIGN_OUT,
                      });
                      setShowLogOutDropdown(false);
                      history.push("/");
                    }}
                  >
                    Logout
                  </button>
                </div>
              </li>
            ) : (
              <li className="nav-item">
                <button
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#login-modal"
                  onClick={() => {
                    dispatch({
                      type: MainPageEvent.SHOW_SIGNIN_MODAL,
                    });
                  }}
                >
                  Sign In
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
